const messages = {
  en: {
    translations: {
      signup: {
        title: "Sign up",
        toasts: {
          success: "User created successfully! Please login!",
          fail: "Error creating user. Check the reported data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
        },
      },
      auth: {
        toasts: {
          success: "Login successfully!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets today: ",
          },
        },
        messages: {
          inAttendance: {
            title: "In Service",
          },
          waiting: {
            title: "Waiting",
          },
          closed: {
            title: "Closed",
          },
        },
      },
      connections: {
        title: "Connections",
        toasts: {
          deleted: "WhatsApp connection deleted sucessfully!",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? It cannot be reverted.",
          disconnectTitle: "Disconnect",
          disconnectMessage: "Are you sure? You'll need to read QR Code again.",
        },
        buttons: {
          add: "Add WhatsApp",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          connecting: "Connectiing",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your cell phone is connected to the internet and try again, or request a new QR Code",
          },
          qrcode: {
            title: "Waiting for QR Code read",
            content:
              "Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
          },
          connected: {
            title: "Connection established",
          },
          timeout: {
            title: "Connection with cell phone has been lost",
            content:
              "Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
          },
        },
        table: {
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
        },
      },
      whatsappModal: {
        title: {
          add: "Add WhatsApp",
          edit: "Edit WhatsApp",
        },
        form: {
          name: "Name",
          default: "Default",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "WhatsApp saved successfully.",
      },
      qrCode: {
        message: "Read QrCode to start the session",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact deleted sucessfully!",
        },
        searchPlaceholder: "Search ...",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related tickets will be lost.",
          importMessage: "Do you want to import all contacts from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
        },
        table: {
          name: "Name",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
      },
      crmKanban: {
        title: "CRM Kanban",
        newLead: "New Lead",
        manageStages: "Manage Stages",
        search: "Search...",
        filters: {
          connection: "Connection",
          attendant: "Attendant",
          all: "All",
        },
        leadModal: {
          title: {
            add: "Add Lead",
            edit: "Edit Lead",
          },
          form: {
            name: "Name",
            number: "WhatsApp number",
            email: "Email",
            value: "Value",
            stage: "Stage",
            connection: "Connection",
            attendant: "Attendant",
            notes: "Notes",
            tag: "Tag",
            channel: "Channel",
            priority: "Priority",
          },
          buttons: {
            okAdd: "Add",
            okEdit: "Save",
            cancel: "Cancel",
            delete: "Delete",
          },
          success: "Lead saved successfully.",
          deleted: "Lead deleted successfully.",
          confirmDeleteTitle: "Delete Lead",
          confirmDeleteMessage:
            "Are you sure you want to delete this lead? This action cannot be undone.",
        },
        stagesModal: {
          title: "Manage Stages",
          newStagePlaceholder: "New stage name",
          saved: "Stage saved successfully.",
          deleted: "Stage deleted successfully.",
          confirmDeleteTitle: "Delete Stage",
          confirmDeleteMessage:
            "Are you sure? Leads in this stage will be moved to the first stage.",
          buttons: {
            add: "Add",
            save: "Save",
            delete: "Delete",
            close: "Close",
          },
        },
      },
      crmPermissions: {
        title: "CRM Permissions",
        columns: {
          name: "Name",
          email: "Email",
          profile: "Profile",
        },
        toggles: {
          kanbanAccess: "Kanban access",
          manageStages: "Manage stages",
        },
      },
      contactModal: {
        title: {
          add: "Add contact",
          edit: "Edit contact",
        },
        form: {
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          number: "Whatsapp number",
          email: "Email",
          extraName: "Field name",
          extraValue: "Value",
        },
        buttons: {
          addExtraInfo: "Add information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
      },
      quickAnswersModal: {
        title: {
          add: "Add Quick Reply",
          edit: "Edit Quick Answer",
        },
        form: {
          shortcut: "Shortcut",
          message: "Quick Reply",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Quick Reply saved successfully.",
      },
      queueModal: {
        title: {
          add: "Add queue",
          edit: "Edit queue",
        },
        form: {
          name: "Name",
          color: "Color",
          greetingMessage: "Greeting Message",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
      },
      distributionRuleModal: {
        title: {
          add: "New distribution rule",
          edit: "Edit distribution rule",
        },
        form: {
          whatsapp: "Connection",
          allConnections: "All",
          queue: "Queue",
          allQueues: "All",
          strategy: "Strategy",
          members: "Agents",
          membersHelper:
            "Without selected agents, the rule uses the queue's agents (or every regular user for a general rule).",
          noUsers: "No agents found",
          keepOwnerOnReopen: "Keep owner on reopen",
          enabled: "Rule enabled",
        },
        strategies: {
          round_robin: "Round robin",
          least_open: "Least busy",
          random: "Random",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Distribution rule saved successfully.",
      },
      userModal: {
        title: {
          add: "Add user",
          edit: "Edit user",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          profile: "Profile",
          whatsapp: "Default Connection",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "User saved successfully.",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      tickets: {
        toasts: {
          deleted: "The ticket you were on has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search tickets and messages.",
        },
        buttons: {
          showAll: "All",
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to queue",
        fieldConnectionLabel: "Transfer to connection",
        fieldQueuePlaceholder: "Please select a queue",
        fieldConnectionPlaceholder: "Please select a connection",
        noOptions: "No user found with this name",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      ticketsList: {
        pendingHeader: "Queue",
        assignedHeader: "Working on",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage: "No tickets found with this status or search term.",
        connectionTitle: "Connection that is currently being used.",
        buttons: {
          accept: "Accept",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          tickets: "Tickets",
          contacts: "Contacts",
          crmKanban: "CRM Kanban",
          quickAnswers: "Quick Answers",
          queues: "Queues",
          administration: "Administration",
          users: "Users",
          crmPermissions: "CRM Permissions",
          settings: "Settings",
          saleAuditDashboard: "AI Audit",
          saleAudits: "Audits",
        },
        appBar: {
          user: {
            profile: "Profile",
            logout: "Logout",
          },
        },
      },
      notifications: {
        noTickets: "No notifications.",
      },
      queues: {
        title: "Queues",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting message",
          actions: "Actions",
        },
        buttons: {
          add: "Add queue",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? It cannot be reverted! Tickets in this queue will still exist, but will not have any queues assigned.",
        },
      },
      queueSelect: {
        inputLabel: "Queues",
      },
      quickAnswers: {
        title: "Quick Answers",
        table: {
          shortcut: "Shortcut",
          message: "Quick Reply",
          actions: "Actions",
        },
        buttons: {
          add: "Add Quick Reply",
        },
        toasts: {
          deleted: "Quick Reply deleted successfully.",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Quick Reply: ",
          deleteMessage: "This action cannot be undone.",
        },
      },
      users: {
        title: "Users",
        table: {
          name: "Name",
          email: "Email",
          profile: "Profile",
          whatsapp: "Default Connection",
          actions: "Actions",
        },
        buttons: {
          add: "Add user",
        },
        toasts: {
          deleted: "User deleted sucessfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Users' open tickets will be moved to queue.",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        settings: {
          userCreation: {
            name: "User creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          saleAuditOnClose: {
            name: "Automatic audit when closing a ticket",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
        },
        distributionRules: {
          title: "Lead distribution",
          description:
            "Automatically assigns new tickets to an agent, by connection and/or queue.",
          scope: {
            all: "Global",
          },
          membersCount: "{{count}} agent(s)",
          empty: "No distribution rules registered.",
          deleteSuccess: "Distribution rule deleted successfully.",
          buttons: {
            add: "New rule",
          },
          confirmationModal: {
            title: "Delete distribution rule",
            message:
              "Tickets already assigned are not affected. New tickets within this rule's scope stop being distributed automatically. Do you want to continue?",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
          },
        },
      },
      messagesInput: {
        placeholderOpen:
          "Type a message or press ''/'' to use the registered quick responses",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
      },
      saleAudit: {
        stages: {
          abordagem: "Approach",
          descoberta: "Discovery",
          oferta: "Offer",
          objecao: "Objection",
          fechamento: "Closing",
          pos_venda: "After-sales",
        },
        temperatures: {
          quente: "Hot",
          morno: "Warm",
          frio: "Cold",
        },
        outcomes: {
          ganhou: "Won",
          negociando: "Negotiating",
          perdeu: "Lost",
          sem_venda: "No sale",
        },
        badges: {
          excelente: "Excellent",
          bom: "Good",
          ruim: "Poor",
        },
        verdicts: {
          good: "Good",
          warn: "Warning",
          bad: "Bad",
        },
        kinds: {
          good: "Positive",
          warn: "Warning",
          bad: "Negative",
          neutral: "Neutral",
        },
        emotions: {
          irritado: "Irritated",
          confuso: "Confused",
          neutro: "Neutral",
          tranquilo: "Calm",
          satisfeito: "Satisfied",
        },
        impacts: {
          alto: "High",
          medio: "Medium",
          baixo: "Low",
        },
        levels: {
          junior: "Junior",
          pleno: "Mid-level",
          senior: "Senior",
        },
        vsTeam: {
          acima: "Above team",
          na_media: "Team average",
          abaixo: "Below team",
        },
      },
      saleAuditDashboard: {
        title: "Service Audit (AI)",
        loading: "Loading…",
        tabs: {
          quality: "Quality",
          conversations: "Conversations",
          sales: "Sales",
        },
        filters: {
          dateFrom: "From",
          dateTo: "To",
          connection: "Connection",
          allConnections: "All",
          user: "Agent",
          allUsers: "All",
        },
        kpis: {
          audited: "Audited",
          conversion: "Conversion",
          wonValue: "Won (R$)",
          lostValue: "Lost (R$)",
          avgScore: "Avg. score",
          badConversations: "Poor conversations",
          agents: "Agents rated",
        },
        quality: {
          bands: {
            excelente: "Excellent",
            bom: "Good",
            regular: "Fair",
            ruim: "Poor",
          },
          distribution: {
            title: "Score distribution",
            empty: "No conversations audited in this period.",
          },
          trend: {
            title: "Average score over time",
            avgScore: "Avg. score",
            empty: "No score history in this period.",
          },
          ranking: {
            title: "Agent ranking",
            user: "Agent",
            audited: "Audited",
            avgScore: "Avg. score",
            worstCategory: "Worst category",
            empty: "No agents audited in this period.",
          },
          needsAttention: {
            title: "Needs attention",
            description: "The 10 lowest-scoring conversations in the period.",
            score: "Score",
            contact: "Customer",
            user: "Agent",
            topIssue: "Main issue",
            empty: "No critical conversations in this period.",
          },
        },
        funnel: {
          title: "Sales funnel",
        },
        ranking: {
          title: "Sales ranking",
          user: "Seller",
          audited: "Audited",
          conversion: "Conversion",
          avgScore: "Average score",
          empty: "No seller audited in the period.",
        },
        lostReasons: {
          title: "Loss reasons",
          empty: "No loss reasons recorded.",
        },
        hotPending: {
          title: "Stalled hot leads",
          description: "Hot negotiations with no new analysis in 24 hours.",
          inNegotiation: "in negotiation",
          cta: "View audits",
        },
        training: {
          title: "Where to train the team",
          worst: "Worst categories",
          rest: "Other categories",
          empty: "No category averages in this period.",
        },
      },
      saleAudits: {
        title: "Service Audits",
        tabs: {
          all: "All",
        },
        filters: {
          outcome: "Outcome",
          all: "All",
        },
        table: {
          contact: "Customer",
          user: "Agent",
          score: "Score",
          stage: "Stage",
          temperature: "Temperature",
          potentialValue: "Potential value",
          outcome: "Outcome",
          suggestedAction: "Next action",
          firstContact: "First contact",
          lastContact: "Last contact",
          sortAscending: "Sorted ascending",
          sortDescending: "Sorted descending",
        },
        groups: {
          label: "Group by",
          none: "None",
          user: "Agent",
          connection: "Connection",
          day: "Day",
          noUser: "No agent",
          summary: "{{count}} conversation(s) · average score {{avgScore}}",
          summaryNoScore: "{{count}} conversation(s)",
        },
        buttons: {
          loadMore: "Load more",
        },
        empty: "No audits found.",
      },
      saleAuditDrawer: {
        header: "AI Audit",
        empty: {
          title: "This ticket has not been analyzed yet.",
          description:
            "Run the analysis to get score, signals and the next play.",
        },
        score: "Service score",
        probability: "Probability",
        potentialValue: "Potential value",
        confidence: "Confidence",
        model: "Model",
        analysisTime: "Analysis",
        analyzedAt: "Analyzed at",
        summary: "Executive summary",
        suggestedAction: "Next action",
        suggestedMessage: "Suggested play",
        sections: {
          play: "Suggested play",
          categories: "Category scores",
          benchmark: "Compared to the team",
          timeline: "Commented timeline",
          events: "Key events",
          emotions: "Emotional evolution",
          positives: "Highlights",
          issues: "Issues",
          missed: "Missed opportunities",
          coaching: "Coaching",
        },
        evidence: {
          show: "Show evidence",
          hide: "Hide evidence",
          msgRef: "msg #",
          empty: "No evidence.",
        },
        benchmark: {
          betterThan: "Better than {{pct}}% of conversations",
          sampleSize: "Sample: {{count}} audited conversations",
          vsTeamAvg: "{{score}} · team average {{teamAvg}}",
        },
        timeline: {
          client: "Customer",
          seller: "Seller",
        },
        coaching: {
          train: "Train",
          level: "Level",
          vsTeam: "Vs team",
          improveProb: "Improvement prob.",
        },
        toasts: {
          copied: "Message copied.",
          copyError: "Could not copy the message.",
        },
        buttons: {
          analyze: "Analyze with AI",
          reanalyze: "Reanalyze",
          copy: "Copy",
        },
      },
      audioTranscription: {
        label: "automatic transcription",
        seeFull: "See full transcription",
      },
      saleAuditDetail: {
        finalScore: "Final score",
        seller: "Agent",
        connection: "Connection",
        weight: "weight",
        opinion: "AI opinion",
        conversation: {
          title: "Audited conversation",
          empty: "This ticket has no messages.",
          unmatched: "AI comments without a matching message",
          media: "[media]",
          mediaAudio: "🎵 audio",
          mediaImage: "🖼️ image",
          mediaVideo: "🎬 video",
          mediaFile: "📎 file",
          mediaLocation: "📍 location",
          mediaContact: "👤 contact",
          transcriptionLabel: "automatic transcription",
        },
        buttons: {
          print: "Print / PDF",
          openFull: "Open full audit",
        },
      },
      contactDrawer: {
        header: "Contact details",
        buttons: {
          edit: "Edit contact",
        },
        extraInfo: "Other information",
      },
      ticketOptionsMenu: {
        delete: "Delete",
        transfer: "Transfer",
        confirmationModal: {
          title: "Delete ticket #",
          titleFrom: "from contact ",
          message: "Attention! All ticket's related messages will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be reverted.",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one queue.",
        ERR_DISTRIBUTION_RULE_SCOPE_ALREADY_EXISTS:
          "A distribution rule already exists for this connection/queue.",
        ERR_DISTRIBUTION_RULE_INVALID_STRATEGY:
          "Invalid distribution strategy.",
        ERR_NO_SALE_AUDIT_FOUND: "This ticket has not been audited yet.",
        ERR_CRM_FUNNEL_NOT_FOUND: "Funnel not found.",
        ERR_CRM_FUNNEL_INVALID_NAME: "Enter a valid funnel name.",
        ERR_CRM_FUNNEL_INVALID_COLOR: "Invalid funnel color.",
        ERR_CRM_FUNNEL_NAME_ALREADY_EXISTS:
          "A funnel with this name already exists.",
        ERR_CRM_FUNNEL_INVALID_ORDER: "Invalid funnel order.",
        ERR_FUNNEL_DEFAULT_UNDELETABLE: "The default funnel cannot be deleted.",
        ERR_FUNNEL_HAS_LEADS:
          "This funnel still has leads. Move or delete them before deleting the funnel.",
        ERR_CRM_NO_FUNNEL: "No funnel registered.",
        ERR_CRM_STAGE_INVALID_NAME:
          "Enter a valid stage name (at least 2 characters).",
        ERR_CRM_STAGE_INVALID_COLOR: "Invalid stage color.",
        ERR_CRM_STAGE_NAME_ALREADY_EXISTS:
          "A stage with this name already exists in this funnel.",
        ERR_CRM_STAGE_INVALID_KIND: "Invalid stage kind.",
        ERR_CRM_STAGE_INVALID_ORDER: "Invalid stage order.",
        ERR_CRM_STAGE_NOT_IN_FUNNEL:
          "Some stages do not belong to this funnel.",
        ERR_CRM_STAGE_NO_FALLBACK:
          "The last stage of a funnel cannot be deleted.",
        ERR_CRM_AUTOMATION_INVALID_TRIGGER: "Invalid automation trigger.",
      },
    },
  },
};

export { messages };
